<template>
  <Dialog
    id="PromptDialog"
    ref="Dialog"
    :class="this.type"
    :title="this.scopedStrings[this.type]"
  >
    <p class="message" v-html="this.message"></p>
  </Dialog>
</template>

<script>
  import Dialog from './Dialog.vue'

  export default {
    props: {
      scopedStrings: {
        type: Object,
        required: true
      }
    },
    components: {
      Dialog
    },
    data () {
      return {
        type: "error",
        message: "",
        showState: false
      }
    },
    methods: {
      buildMessage (type, message, detail) {
        if (detail === undefined) {
          return message
        } else {
          return message + '<br><blockquote class="' + type + '">' + detail + '</blockquote>'
        }
      },
      show (type, message, detail) {
        this.type = type
        this.message = this.buildMessage(type, message, detail)
        this.$refs.Dialog.show()
      }
    }
  }
</script>

<style>
  .error .dialog-heading {
    background-color: var(--error);
  }

  blockquote.error {
    border-left: 6px solid var(--error);
  }

  .success .dialog-heading {
    background-color: var(--success);
  }

  blockquote.success {
    border-left: 6px solid var(--success);
  }

  .warning .dialog-heading {
    background-color: var(--warning);
  }

  blockquote.warning {
    border-left: 6px solid var(--warning);
  }

  #PromptDialog p {
    margin: 0;
    padding: 20px;
  }

  #PromptDialog p > blockquote {
    margin: 16px;
    margin-left: 0;
    padding: 16px;
    background-color: var(--background-light);
  }
</style>
